'use client'

import type { ReactElement } from 'react'
import { Text, TextProps } from '../../../MyStichtingOpenComponents/src/static'
import Link from 'next/link'
import { useTranslations } from '@/helpers/useTranslations'
import { Routes } from '@/constants/routeConstants'

export const LinkToLoginPage = (props: Omit<TextProps, 'children'>): ReactElement => {
    const translate = useTranslations()

    return (
        <Text {...props}>
            <Link href={Routes.LOGIN}>{translate('FOOTER_LOGIN_TEXT')}</Link>
        </Text>
    )
}
